module.exports = __webpack_public_path__ + "img/ic_trending_active.056a05f8.svg";